import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize theme BEFORE React renders to prevent flash of unstyled content
const initializeTheme = () => {
  const savedTheme = localStorage.getItem('cgr-theme');
  let themeToApply: 'light' | 'dark';
  
  if (savedTheme === 'light' || savedTheme === 'dark') {
    themeToApply = savedTheme;
  } else {
    // For 'system' or no saved theme, detect system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    themeToApply = prefersDark ? 'dark' : 'light';
  }
  
  document.documentElement.setAttribute('data-theme', themeToApply);
};

// Apply theme immediately before render
initializeTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
